import { createStyles, Theme } from '@material-ui/core';

const styles = ({ colors, spacing }: Theme) => createStyles({
  container: {
    borderLeft: `2px solid ${colors.pageElements.profileCard.infoDivider}`,
    paddingLeft: spacing(2),
  },
  caption: {
    color: colors.pageElements.profileCard.infoLabel,
    marginBottom: spacing(1),
  },
  text: {
    color: colors.pageElements.profileCard.infoText,
  },
});

export default styles;
